import { AvatarSize, AvatarVariant } from './avatar.model';

export const AVATAR_DEFAULT_CONFIG = {
  variant: AvatarVariant.Circle,
  size: AvatarSize.Small,
  disableHovering: true,
};
